// extracted by mini-css-extract-plugin
export var brand = "_8e-8";
export var compact = "_8e-5";
export var extraSmall = "_8e-6";
export var icon = "_8e-0";
export var large = "_8e-3";
export var light = "_8e-1";
export var medium = "_8e-4";
export var outline = "_8e-a";
export var primaryDark = "_8e-9";
export var primaryLight = "_8e-7";
export var primaryModern = "_8e-b";
export var success = "_8e-2";